import { render } from "./customers.vue?vue&type=template&id=3794375a"
import script from "./customers.vue?vue&type=script&lang=ts"
export * from "./customers.vue?vue&type=script&lang=ts"
script.render = render

export default script